// src/pages/maintenance/components/MaintenanceContractList/ViewMaintenanceContractModal.jsx

import React, { useEffect, useState } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import EditMaintenanceContractModal from './EditMaintenanceContractModal'; // Ensure correct import
import {
  ContractDetailsFields,
  CoverageFields,
  BillingInformationFields,
  IncreaseDetailsFields,
} from './maintenanceContractFields'; // Ensure these fields are correctly defined
import API_BASE_URL from '../../../../Constants';

const ViewMaintenanceContractModal = ({
  open,
  handleClose,
  contractId,
  refreshContracts,
}) => {
  const [contract, setContract] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEditOpen, setIsEditOpen] = useState(false); // Local state for edit modal

  const fetchContract = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/maintenance/maintenance-contracts/${contractId}`, {
        credentials: 'include'
      });
      const data = await response.json();
      setContract(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching contract:', error);
      setContract(null);
      setLoading(false);
    }
  };


  useEffect(() => {
    if (open && contractId) {
      fetchContract();
    }
  }, [open, contractId]);

  const handleOpenEditModal = () => {
    setIsEditOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditOpen(false);
    refreshContracts(); // Refresh the list after editing
  };

  // Render a single field
  const renderField = (field) => {
    return (
      <div key={field.name} className="flex flex-col mb-4 w-full">
        <Typography variant="subtitle1" className="font-semibold">
          {field.label}:
        </Typography>
        <Typography variant="body1">
          {contract[field.name] || 'N/A'}
        </Typography>
      </div>
    );
  };

  if (!open) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
      <DialogTitle className="text-2xl font-bold">View Maintenance Contract</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Typography>Loading...</Typography>
        ) : contract ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Contract Details */}
            <div className="border border-gray-300 rounded-lg p-4">
              <h3 className="text-lg font-semibold mb-4">Contract Details</h3>
              {ContractDetailsFields.map(renderField)}
            </div>

            {/* Coverage */}
            <div className="border border-gray-300 rounded-lg p-4">
              <h3 className="text-lg font-semibold mb-4">Coverage</h3>
              {CoverageFields.map(renderField)}
            </div>

            {/* Billing Information */}
            <div className="border border-gray-300 rounded-lg p-4">
              <h3 className="text-lg font-semibold mb-4">Billing Information</h3>
              {BillingInformationFields.map(renderField)}
            </div>

            {/* Increase Details */}
            <div className="border border-gray-300 rounded-lg p-4">
              <h3 className="text-lg font-semibold mb-4">Increase Details</h3>
              {IncreaseDetailsFields.map(renderField)}
            </div>
          </div>
        ) : (
          <Typography>No contract details available.</Typography>
        )}
      </DialogContent>
      <DialogActions className="justify-end p-4">
        <Button onClick={handleOpenEditModal} color="primary" variant="contained">
          Edit
        </Button>
        <Button onClick={handleClose} color="secondary" variant="outlined">
          Cancel
        </Button>
      </DialogActions>

      {/* Edit Maintenance Contract Modal */}
      {isEditOpen && (
        <EditMaintenanceContractModal
          open={isEditOpen}
          handleClose={handleCloseEditModal}
          contractId={contractId}
          refreshContracts={refreshContracts}
        />
      )}
    </Dialog>
  );
};

export default ViewMaintenanceContractModal;
